<template>
  <div>
    <tiptap-vuetify
      v-model="text"
      :extensions="extensions"
      :placeholder="placeholder"
    />
    <span class="error--text" v-text="errorMessages"></span>
  </div>
</template>
<script>
import {
  TiptapVuetify,
  Bold,
  Italic,
  Strike,
  Underline,
  OrderedList,
  ListItem
} from "tiptap-vuetify";
export default {
  components: { TiptapVuetify },
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    errors: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      extensions: [Bold, Underline, Strike, Italic, OrderedList, ListItem],
      text: this.value
    };
  },
  watch: {
    text(val) {
      this.$emit("input", val);
      this.$emit("blur");
    },
    value() {
      this.text = this.value;
    }
  }
};
</script>
<style scoped></style>
